import Box from "@mui/material/Box";
import { useFrozenClientTabBreadcrumbs } from "Helpers/useFrozenClientBreadcrumbs";
import { useCallback, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import AlertMessages from "common/Alert/AlertMessages";
import { useTranslation } from "react-i18next";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import Loader from "layout/Loader";
import BackendPaginationTable from "common/Table/TableWithPagination";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import StyledInput from "common/SearchField/Search";
import { useGetDriversService } from "subModule/src/services/client/useClient";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ChangeStatusUserResponse } from "subModule/src/services/user/interface";
import FormDialog from "common/Modal/Modal";
import { UserModuleProfileService } from "subModule/src/core/services";
import { DeleteData } from "subModule/src/type";
import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { ReactComponent as Client } from "assets/SideBarIcons/customer.svg";
import { DriverResponse } from "@subModule/src/services/client/interface";

export default function DriversListing() {
  const navigate = useNavigate();
  const params = useParams();
  const [pageNo, setPageNo] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(5);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<any>("");
  const [search, setSearch] = useState("");
  const [openDeleteModal, setDeleteModal] = useState(false);
  const [row, setRow] = useState<DriverResponse>();
  const [statusModal, setStatusModal] = useState(false);
  const {
    data: tableData,
    isFetching,
    refetch,
  } = searchTerm
    ? useGetDriversService(
        { pageNumber: pageNo, size: pageSize, type: 180, name: search },
        +(params as any)?.accountId,
      )
    : useGetDriversService(
        { pageNumber: pageNo, size: pageSize, type: 180 },
        +(params as any)?.accountId,
      );
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const breadcrumbItems = useFrozenClientTabBreadcrumbs("drivers");
  const fetchData = useCallback(() => {
    refetch().then((res: any) => {
      if (!res?.data?.pages[0]?.success)
        enqueueSnackbar(
          <AlertMessages
            text={res?.data?.pages[0]?.message || "Something went wrong"}
          />,
          { variant: "error" },
        );
    });
  }, []);
  useEffect(() => {
    fetchData();
  }, [pageNo, pageSize, searchTerm]);
  const handleChangePage = (pageNo: number) => {
    setPageNo(pageNo + 1);
  };
  const handleChangeRows = (pageSize: number) => {
    setPageSize(pageSize);
    setPageNo(1);
  };
  const onEdit = (row: any) =>
    navigate(
      `/client/${params?.id}/account/${params?.accountId}/driver/` +
        row.id +
        "/invoicingPreference/" +
        params?.invoicingPreference,
    );
  const showRowView = (row: any) =>
    navigate(
      `/client/${params?.id}/account/${params?.accountId}/driver/` +
        row.id +
        "/invoicingPreference/" +
        params?.invoicingPreference,
    );
  const onDelete = (row: any) => {
    setDeleteModal(true);
    setRow(row);
  };
  const clearSearch = () => {
    setSearch("");
    setSearchTerm("");
    if (searchTerm) {
      handleSearch("");
    }
  };
  const handleSearch = (search: string) => {
    setSearchTerm(search);
    setPageNo(1);
    setPageSize(pageSize);
  };
  const handleSearchClick = () => {
    const trimmedSearch = search.trim();
    if (trimmedSearch !== "") {
      handleSearch(trimmedSearch);
    }
  };
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value.trim());
    if (!event.target.value.trim()) handleSearch("");
  };
  const onChangeStatus = (row: any) => {
    setRow(row);
    setStatusModal(true);
  };
  const actionslist = [
    { label: "edit", onClick: onEdit, icon: <EditIcon /> },
    { label: "delete", onClick: onDelete, icon: <DeleteIcon /> },
  ];
  const adjustActions = (actions: any[]) => {
    return checkPrivileges("ROLE_CLIENT_UPDATE")
      ? checkPrivileges("ROLE_CLIENT_ARCHIVE")
        ? actions
        : actions.filter((action) => action.label !== "delete")
      : checkPrivileges("ROLE_CLIENT_ARCHIVE")
        ? actions.filter((action) => action.label !== "edit")
        : [];
  };
  const handleChangeTabs = (tabId: number) => {
    if (tabId === 0)
      navigate(
        `/client/${params?.id}/account/${params?.accountId}/invoicingPreference/${params?.invoicingPreference}`,
      );
    else if (tabId === 1)
      navigate(
        `/client/${params?.id}/account/${params?.accountId}/update-password/invoicingPreference/${params?.invoicingPreference}`,
      );
    else if (tabId === 2)
      navigate(
        `/client/${params?.id}/account/${params?.accountId}/drivers/invoicingPreference/${params?.invoicingPreference}`,
      );
    else if (tabId === 3)
      navigate(
        `/client/${params?.id}/account/${params?.accountId}/vehicles/invoicingPreference/${params?.invoicingPreference}`,
      );
    else if (tabId === 4)
      navigate(
        `/client/${params?.id}/account/${params?.accountId}/invoices/invoicingPreference/${params?.invoicingPreference}`,
      );
    else if (tabId === 5)
      navigate(
        `/client/${params?.id}/account/${params?.accountId}/delivery-notes/invoicingPreference/${params?.invoicingPreference}`,
      );
    else if (tabId === 6)
      navigate(
        `/client/${params?.id}/account/${params?.accountId}/payments/invoicingPreference/${params?.invoicingPreference}`,
      );
    else if (tabId === 7)
      navigate(
        `/client/${params?.id}/account/${params?.accountId}/reviews/invoicingPreference/${params?.invoicingPreference}`,
      );
    else if (tabId === 8)
      navigate(
        `/client/${params?.id}/account/${params?.accountId}/integrations/invoicingPreference/${params?.invoicingPreference}`,
      );
  };
  const tabs = [
    { id: 0, title: `edit`, child: <></> },
    { id: 1, title: `updatePassword`, child: <></> },
    { id: 2, title: `drivers`, child: <></> },
    { id: 3, title: `vehicles`, child: <></> },
    { id: 4, title: `invoices`, child: <></> },
    { id: 5, title: `deliveryNotes`, child: <></> },
    { id: 6, title: `payments`, child: <></> },
    { id: 7, title: `reviews`, child: <></> },
    { id: 8, title: `integrations`, child: <></> },
  ];
  const disableTabs = tabs
    .map((tab) => tab.id)
    .filter((tabId) => {
      switch (tabId) {
        case 0:
          return !checkPrivileges("ROLE_CLIENT_UPDATE");
        case 1:
          return !checkPrivileges("ROLE_CHANGE_PASSWORD");
        case 2:
          return !checkPrivileges("ROLE_CLIENT_UPDATE");
        case 3:
          return !checkPrivileges("ROLE_VEHICLE_VIEW");
        case 4:
          return !checkPrivileges("ROLE_INVOICE_VIEW");
        case 5:
          return !checkPrivileges("ROLE_DELIVERY_NOTE_VIEW");
        case 6:
          return !checkPrivileges("ROLE_PAYMENT_VIEW");
        case 7:
          return false;
        case 8:
          return false;
        default:
          return false;
      }
    });
  // const checkDisabledTabs = () => {
  //   const updatedDisableTabs = [...disableTabs];
  //   if (Number(params?.invoicingPreference) !== 2) {
  //     if (!updatedDisableTabs.includes(5)) {
  //       updatedDisableTabs.push(5);
  //     }
  //   }

  //   return updatedDisableTabs;
  // }
  return (
    <>
      <ComponentHeaderTwo
        showBtn={true}
        showSaveBtn={checkPrivileges("ROLE_CLIENT_CREATE")}
        onClick={() => navigate("/clients")}
        onSubmit={() =>
          navigate(
            `/client/${params?.id}/account/${params?.accountId}/driver/create/invoicingPreference/${params?.invoicingPreference}`,
          )
        }
        heading={t("customer") + " (" + t("company") + ")"}
        icon={
          <Client
            style={{
              fill: "#000",
              width: "30px",
              height: "30px",
              marginTop: "3px",
            }}
          />
        }
        btnText={"back"}
        btnType={"back"}
        showCreateBtn={false}
        saveBtnText={"create"}
        isBtnEnabled={true}
        breadcrumbItems={breadcrumbItems}
      />
      <Box className="flex">
        <VerticalTabs
          tabs={tabs}
          selectedIndex={2}
          handleChangeTabs={handleChangeTabs}
          disableTabNo={disableTabs}
        />
        <div className="w-[100%] mt-[10px]">
          <Box>
            {isFetching || loading ? (
              <Loader />
            ) : (
              <div id="mainListingTable">
                <BackendPaginationTable
                  columns={[
                    { id: "name", label: "name", numeric: false },
                    { id: "userNameClient", label: "email", numeric: false },
                    ...(checkPrivileges("ROLE_CLIENT_ACTIVE")
                      ? [{ id: "active", label: "status", numeric: false }]
                      : []),
                    ...(adjustActions(actionslist).length
                      ? [{ id: "actions", label: "actions", numeric: false }]
                      : []),
                  ]}
                  data={tableData?.pages[0]?.data?.content || []}
                  pageNo={pageNo}
                  pageSize={pageSize}
                  tableData={tableData?.pages[0]?.data || {}}
                  showCheckbox={false}
                  showActions={true}
                  enableSorting={true}
                  showHeader={true}
                  showSearch={true}
                  showFilter={true}
                  showCreateButton={true}
                  actions={adjustActions(actionslist)}
                  handleChangePage={handleChangePage}
                  handleChangeRows={handleChangeRows}
                  onChangeStatus={onChangeStatus}
                  rowClick={checkPrivileges("ROLE_CLIENT_UPDATE")}
                  showRowView={showRowView}
                  loadingSearch={false}
                  headerComponent={
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={7} lg={5}>
                        <StyledInput
                          fullWidth
                          placeholder={t("name")}
                          handleSearchClick={handleSearchClick}
                          handleChange={handleInputChange}
                          value={search}
                          clearSearch={clearSearch}
                        />
                      </Grid>
                    </Grid>
                  }
                />
              </div>
            )}
          </Box>
        </div>
        {openDeleteModal && (
          <FormDialog
            open={openDeleteModal}
            onClose={() => setDeleteModal(false)}
            title={t("delete") + " " + t("driver")}
            content={
              <Grid container>
                <Grid item xs={12}>
                  <Typography>
                    {t("Are you sure you want to delete?")}
                  </Typography>
                </Grid>
              </Grid>
            }
            saveFunction={() => {
              setLoading(true);
              setDeleteModal(false);
              UserModuleProfileService.deleteUser((row as any).id)
                .then((response: DeleteData) => {
                  if (response.success) {
                    if (
                      tableData?.pages[0]?.data?.content?.length === 1 &&
                      pageNo > 1
                    )
                      setPageNo(1);
                    else refetch();
                    enqueueSnackbar(
                      <AlertMessages
                        statusCode={response.status}
                        text={
                          t("driver") +
                          " " +
                          t("deleted") +
                          " " +
                          t("successfully")
                        }
                      />,
                      { variant: "success" },
                    );
                  } else {
                    enqueueSnackbar(
                      <AlertMessages statusCode={response.status} />,
                      { variant: "error" },
                    );
                  }
                })
                .catch((err: any) => {
                  console.error("===", err);
                  enqueueSnackbar(
                    <AlertMessages
                      text={err?.data?.message || err || "Something went wrong"}
                    />,
                    { variant: "error" },
                  );
                })
                .finally(() => setLoading(false));
            }}
            submitButtonText="Delete"
          />
        )}
        {statusModal && (
          <FormDialog
            open={statusModal}
            onClose={() => setStatusModal(false)}
            title="Change Status"
            // icon={<div><Home/></div>}
            content={
              <Grid container>
                <Grid item xs={12}>
                  <Typography>{t(`Are you sure?`)}</Typography>
                </Grid>
              </Grid>
            }
            saveFunction={() => {
              setStatusModal(false);
              setLoading(true);
              UserModuleProfileService.changeStatusUser(
                (row as any).id,
                row?.active ? "inactive" : "active",
                {},
              )
                .then((response: ChangeStatusUserResponse) => {
                  if (response.success) {
                    refetch();
                    enqueueSnackbar(
                      <AlertMessages
                        statusCode={response.status}
                        text={
                          t("status") +
                          " " +
                          t("changed") +
                          " " +
                          t("successfully")
                        }
                      />,
                      { variant: "success" },
                    );
                  } else {
                    enqueueSnackbar(
                      <AlertMessages statusCode={response.status} />,
                      { variant: "error" },
                    );
                  }
                })
                .catch((err: any) => {
                  console.error("===", err);
                  enqueueSnackbar(
                    <AlertMessages
                      text={err?.data?.message || err || "Something went wrong"}
                    />,
                    { variant: "error" },
                  );
                })
                .finally(() => setLoading(false));
            }}
            submitButtonText="OK"
          />
        )}
      </Box>
    </>
  );
}
